define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {

        },

        init: function () {
            let self = this;

            document.querySelectorAll('.Tabs-link').forEach(t => {  
                t.addEventListener('click', function () {
                    if (stickyHeader.classList.contains('StickyHeader--show')) {
                        window.setTimeout(function () {
                            window.scrollBy(0, 1);
                        }, 100);
                    }
                });
            });

            const header = document.querySelector('.Header');
            const deviceHeader = document.querySelector('.DeviceNav-wrapper')

            if (document.body.classList.contains('js-invertHeader')) {
                deviceHeader.classList.add('StickyHeader--inverted');
                header.classList.add('StickyHeader--inverted');
            }

            let headerHeight;
            let deviceHeaderHight;
            let stickyHeader;
            let headerHeightRef;
            let stickyHeaderHight;
            let topRef;

            const onResize = () => {
                headerHeight = header.getBoundingClientRect().height;
                deviceHeaderHight = deviceHeader.getBoundingClientRect().height;
                stickyHeader = !!headerHeight ? header : deviceHeader;
                headerHeightRef = !!headerHeight ? headerHeight : deviceHeaderHight;
                stickyHeaderHight = !!headerHeight ? '146px' : '60px';
                topRef = !!headerHeight ? header.getBoundingClientRect().top : deviceHeader.getBoundingClientRect().top;
                topRef += window.scrollY;
            }
            onResize();

            let prevScrollY = 0;
            const onScroll = currentScrollY => {
                if (self.disableEvents) {
                    self.disableEvents = false;
                    return;
                }

                const stickyMenu = document.querySelector('.Sticky-element');
                if (currentScrollY < prevScrollY) {
                    if (currentScrollY <= (1 + topRef)) {
                        stickyHeader.classList.remove('StickyHeader--sticky');
                        stickyHeader.classList.remove('StickyHeader--animated');
                    }

                    if (currentScrollY < (headerHeightRef * .2) + topRef) {
                        stickyHeader.classList.remove('StickyHeader--proportions');
                    }

                    if (currentScrollY < (headerHeightRef * .4) + topRef) {
                        stickyHeader.style.height = stickyHeaderHight;
                        stickyHeader.classList.remove('StickyHeader--background')
                    }

                    if (currentScrollY > (headerHeightRef + topRef)) {
                        let wasHidden = !stickyHeader.classList.contains('StickyHeader--show');

                        stickyHeader.classList.add('StickyHeader--proportions');
                        stickyHeader.classList.add('StickyHeader--animated');
                        stickyHeader.classList.add('StickyHeader--show');
                        stickyHeader.style.height = !!headerHeight ? '146px' : '60px';

                        header.classList.add('StickyHeader--sticky', 'StickyHeader--proportions', 'StickyHeader--animated');
                        deviceHeader.classList.add('StickyHeader--sticky', 'StickyHeader--proportions', 'StickyHeader--animated');
                        stickyMenu && stickyMenu.classList.contains('is-sticky') && stickyMenu.classList.add('StickyMenu-offset');

                        if (wasHidden) {
                            self.recalc('show');
                        }
                    }

                } else {
                    if (currentScrollY > (headerHeightRef + topRef)) {
                        let wasVisible = stickyHeader.classList.contains('StickyHeader--show');
                        stickyHeader.classList.remove('StickyHeader--show');
                        stickyHeader.classList.add('StickyHeader--sticky', 'StickyHeader--background');
                        stickyHeader.style.height = !!headerHeight ? '146px' : '60px';

                        stickyMenu && stickyMenu.classList.remove('StickyMenu-offset');

                        if (wasVisible) {
                            self.recalc('hide');
                        }
                    }
                }
                prevScrollY = currentScrollY;
            }

            window.setTimeout(function () {
                window.addEventListener('resize', () => {
                    onResize();
                });

                window.addEventListener('scroll', () => {
                    onScroll(window.scrollY)
                });
            }, 500);
        },

        recalc: function(type) {
            let evt = new Event('recalc');
            document.querySelectorAll('[data-module*=sticky i]:not([data-module*=stickyheader i])').forEach(s => {
                //console.log('dispatch ' + type + ': ' + s);
                s.dispatchEvent(evt);
            });
        }
    });
});